import { AlertTriangle, Info } from 'lucide-react';
import { Button } from './Button';
import { useConfirm } from '@/state/confirm';

/** Глобальный хост confirm-диалогов. Монтируется один раз в App. */
export function ConfirmDialog() {
  const { open, opts, resolve } = useConfirm();
  if (!open || !opts) return null;

  const {
    title,
    body,
    confirmLabel = 'Подтвердить',
    cancelLabel  = 'Отмена',
    destructive  = false,
  } = opts;

  const Icon = destructive ? AlertTriangle : Info;
  const iconColor = destructive ? '#EF4444' : '#F59E0B';

  return (
    <>
      <div
        className="fixed inset-0 z-50 backdrop-blur-sm"
        style={{ background: 'rgba(10,22,40,.6)' }}
        onClick={() => resolve(false)}
      />
      <div
        className="fixed z-50 bg-white rounded-card flex flex-col border border-border"
        style={{
          top: '50%', left: '50%', transform: 'translate(-50%,-50%)',
          width: 'calc(100% - 32px)', maxWidth: 440,
          boxShadow: '0 24px 64px rgba(10,22,40,.24)',
        }}
        role="alertdialog"
        aria-labelledby="confirm-title"
        aria-describedby="confirm-body"
      >
        <div style={{ padding: '28px 24px 0', textAlign: 'center' }}>
          <div
            className="rounded-btn inline-flex items-center justify-center"
            style={{
              width: 48, height: 48,
              background: destructive ? 'rgba(239,68,68,.1)' : 'rgba(245,158,11,.1)',
            }}
          >
            <Icon size={24} stroke={iconColor} />
          </div>
          <h3
            id="confirm-title"
            className="font-heading text-ink mt-4"
            style={{ fontSize: 20, fontWeight: 600, letterSpacing: '-0.01em' }}
          >{title}</h3>
          <p
            id="confirm-body"
            className="text-muted mt-2"
            style={{ fontSize: 14, lineHeight: 1.55 }}
          >{body}</p>
        </div>
        <div className="flex justify-end" style={{ padding: '20px 24px', gap: 12, marginTop: 8 }}>
          <Button variant="ghost" onClick={() => resolve(false)}>{cancelLabel}</Button>
          <Button
            variant="primary"
            onClick={() => resolve(true)}
            style={destructive ? { background: '#EF4444', color: '#FFFFFF' } : undefined}
          >{confirmLabel}</Button>
        </div>
      </div>
    </>
  );
}
